export function formatTime(time: number): string {
  if (isNaN(time)) return '00:00';
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
    2,
    '0',
  )}`;
}

export const getVideoSettings = (videoPlayOption: string) => {
  switch (videoPlayOption) {
    case 'PlayOnClick':
      return { autoPlay: false, loop: false };
    case 'AutoplayLoop':
      return { autoPlay: true, loop: true };
    case 'OpenPopup':
      return { autoPlay: false, loop: false };
    default:
      return { autoPlay: false, loop: false };
  }
};
